<template>
    <div class="font-main text-a-brown-502314 text-center">
        <div class="text-18 lg:text-20 font-bold mb-4">
            {{ lbl.myOrder.orderNo }} {{ orderId }}
        </div>
        <div class="mb-4">
            <img v-if="trackingOrder.vendorStatus == VendorStatus.OrderPlaced" src="@/assets/order/order-placed.svg"
                class="mx-auto" alt="" />
            <img v-else-if="checkVendorStatus(VendorStatus.OnTheWay, VendorStatus.Cooking)"
                src="@/assets/order/cooking.svg" class="mx-auto" alt="" />
            <img v-else src="@/assets/order/pickup-ready.svg" class="mx-auto" alt="" />
        </div>
        <div>
            <div class="text-14 lg:text-16 font-bold mb-2">
                {{ orderStatusText.title }}
            </div>
            <div class="text-14 lg:text-16 text-a-brown-9f8273">
                {{ orderStatusText.subTitle }}
            </div>
        </div>

        <div class="flex items-center my-4 gap-5px max-w-330px mx-auto">
            <div class="flex-grow">
                <div class="h-5px w-full rounded-full bg-a-brown-502314"></div>
            </div>
            <div class="flex-none">
                <div class="leading-none h-2 w-2 rounded-full"
                    :class="[trackingOrder.vendorStatus > VendorStatus.OrderPlaced && trackingOrder.vendorStatus <= VendorStatus.ReadyPickUp ? 'bg-a-brown-502314' : 'bg-a-brown-d7c7b8']">
                </div>
            </div>
            <div class="flex-grow">
                <div class="h-5px w-full rounded-full"
                    :class="[trackingOrder.vendorStatus > VendorStatus.OrderPlaced && trackingOrder.vendorStatus <= VendorStatus.ReadyPickUp ? 'bg-a-brown-502314' : 'bg-a-brown-d7c7b8']">
                </div>
            </div>
            <div class="flex-none">
                <div class="leading-none h-2 w-2 rounded-full"
                    :class="[trackingOrder.vendorStatus == VendorStatus.ReadyPickUp || trackingOrder.vendorStatus == VendorStatus.OrderCompleted ? 'bg-a-brown-502314' : 'bg-a-brown-d7c7b8']">
                </div>
            </div>
            <div class="flex-grow">
                <div class="h-5px w-full rounded-full"
                    :class="[trackingOrder.vendorStatus == VendorStatus.ReadyPickUp || trackingOrder.vendorStatus == VendorStatus.OrderCompleted? 'bg-a-brown-502314' : 'bg-a-brown-d7c7b8']">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { inject, ref, computed } from 'vue'
import { VendorStatusCode } from '@/helper/StaticValue'
import Utility from '@/helper/Utility'
import DatetimeHelper from '@/helper/DatetimeHelper'

export default {
    name: 'Header',
    props: {},
    components: {},
    mixins: [],
    emits: [],
    data: function () { return {} },
    computed: {},
    setup: function () {
        const { lbl, localeCode } = inject("LocaleStore")
        const trackingOrder = inject("getTracking")
        const VendorStatus = VendorStatusCode

        const orderStatusText = ref({
            title: "",
            subTitle: ""
        })

        const orderId = computed(() => {
            return trackingOrder.value.sdmOrderId && trackingOrder.value.sdmOrderId != '' ? trackingOrder.value.sdmOrderId : trackingOrder.value.tranId
        })

        switch (trackingOrder.value.vendorStatus) {
            case VendorStatus.OrderPlaced:
                orderStatusText.value = lbl.value.myOrder.tracking.orderStatus.orderPlaced
                break;
            case VendorStatus.OnTheWay:
                orderStatusText.value = lbl.value.myOrder.tracking.orderStatus.onTheWay
                break;
            case VendorStatus.OrderCompleted:
                orderStatusText.value = lbl.value.myOrder.tracking.orderStatus.orderCompleted
                break;
            case VendorStatus.Cooking:
                orderStatusText.value = lbl.value.myOrder.tracking.orderStatus.cooking
                break;
            case VendorStatus.ReadyPickUp:
                orderStatusText.value = lbl.value.myOrder.tracking.orderStatus.readyPickup
                orderStatusText.value.subTitle = Utility.stringFormat(orderStatusText.value.subTitle, localeCode.value == 1033 ? trackingOrder.value.branchNameEN : trackingOrder.value.branchName)
                break;
            case VendorStatus.Canceled:
                orderStatusText.value = lbl.value.myOrder.tracking.orderStatus.cooking
                orderStatusText.value.subTitle = Utility.stringFormat(orderStatusText.value.subTitle, DatetimeHelper.getDatetimeShortFormat(trackingOrder.value.cancelDate))
                break;
            default:
                break;
        }

        const checkVendorStatus = function () {
            let status = [...arguments]
            if (status.indexOf(trackingOrder.value.vendorStatus) > -1) {
                return true
            }
            return false
        }

        return {
            lbl,
            trackingOrder,
            VendorStatus,
            orderStatusText,
            checkVendorStatus,
            orderId
        }
    },
    mounted: function () { },
    methods: {}
}
</script>
